import { defineMessages } from "react-intl";

export const FormSectionItemText = defineMessages({
  section: {
    defaultMessage: "Section",
    id: "q1Cd7m",
  },
});
